import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=1145772d&scoped=true"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"
import style0 from "./contracts.vue?vue&type=style&index=0&id=1145772d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145772d",
  null
  
)

export default component.exports